/** Minha empresa: o cadastro, quem cuida de cada área, o que vence e a ficha em PDF. */
import { createFileRoute } from '@tanstack/react-router';
import { ComPortal } from '../telas/portal/casca';
import { MinhaEmpresa } from '../telas/portal/paginas';

export const Route = createFileRoute('/portal/empresa')({ component: () => <ComPortal>{(d) => <MinhaEmpresa d={d} />}</ComPortal> });
